<div class="detail-container">

    @if (roomPropertyResource.isLoading()) {
    <property-skeleton />
    } @else if (roomPropertyResource.error()) {
        <error-card/>
    } @else {
        @if (roomPropertyResource.value(); as room) {
        <div class="d-flex gap-4">
            <div>
                <section-header>{{ room.name() }}</section-header>
                @if (is3DViewerEnable()) {
                    <div class="part-viewer">
                        <unity
                          style="display: block; width: 100%; height: 100%;"
                            [cacheContext]="RoomPropertyComponent.cacheContext"
                            [config]="config()"
                            [params]="params()"
                            [security]="security()"
                            [width]="'800px'"
                            [height]="'500px'" />
                    </div>
                } @else {
                    <div class="d-flex flex-wrap gap-4">
                        <document-card [style.view-transition-name]="'card-image'" class="document-card">
                            @if (room.hasImageError()) {
                                <span class="text-center" card-content>{{room.name()}}</span>
                            } @else {
                                <img card-content class="h-100" (error)="room.handleImageError()" [src]="room.thumbnailUrl()" alt="image" />
                            }
                            <is-busy-button card-footer id="open-button" [disabled]="false" (execute)="open3DViewer()"
                                css="btn w-100 clip3 corner position-relative primary-border secondary-bg secondary-text-100 rounded-0 py-1">
                                <span class="font-4">Open 3D Simulator</span>
                            </is-busy-button>
                        </document-card>
                    </div>
                }
            </div>
        </div>

        <div class="mt-4">
            <section-header>Room Properties</section-header>

            <div class="masonry-columns">
                @for (category of room.categories(); track $index) {
                <property-card>
                    <div title class="d-flex align-items-center">
                        @if(!category.hasImageError) {
                            <img height="50" src="{{category.thumbnailUrl()}}"/>
                        }
                        <span>{{ category.name() }}</span>
                    </div>

                    <div content class="d-flex flex-column gap-3 primary-text">
                        <property-item-header />

                        @for (property of category.properties(); track $index) {
                        <property-item-row [name]="property.name()" [value]="property.values()"></property-item-row>
                        }

                        @for (property of category?.roomContents(); track $index) {
                        <property-item-row 
                            [name]="property.code() ? property.code() + ' - ' + property.name() : property.name()" 
                            [value]="property.quantity()"></property-item-row>
                        }
                    </div>
                </property-card>
                } @empty {
                <empty-property-card />
                }
            </div>
        </div>

        <div class="mt-4">
              <carousel [enableHover]="false" [dataSource]="room.documents()" class="carousel">
                  <span carousel-label>Room Documents ({{room.documents().length}})</span>
              </carousel>
        </div>

        <div class="my-6">
              <carousel [dataSource]="roomContents()" [showCount]="true" class="carousel-bottom-center carousel">
                  <span carousel-label>Room Content ({{roomContents().length}})</span>
              </carousel>
        </div>
        }
    }
</div>